import React from "react";
import ReactApexChart from '../../../../components/ReusableComponents/ApexChartLazy';

const BarChart = ({ data }) => {
  const isValidData =
    Array.isArray(data) && data.every((item) => typeof item === "number" && !isNaN(item));
  const sanitizedData = isValidData ? data : [0, 0, 0, 0, 0, 0];

  const options = {
    series: [
      {
        data: sanitizedData,
      },
    ],
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        borderRadiusApplication: "end",
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      max: 100,
      categories: [
        "More Seats",
        "Fans/Acs",
        "Better Lighting",
        "Cleanliness",
        "Barrier Free Access",
        "Other",
      ],
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (val) => `${val}`,
        title: {
          formatter: () => "",
        },
      },
    },
  };

  return (
    <div id="chart">
      <ReactApexChart options={options} series={options.series} type="bar" height={350} />
    </div>
  );
};

export default BarChart;
